// extracted by mini-css-extract-plugin
export default {"accessToken":"ServiceAccountGenerateToken_accessToken__e7AGL","button":"ServiceAccountGenerateToken_button__IYfAp"};